import { useContext } from 'react'
import { Minus } from '../../../icons'
import { NumberInputContext } from '../NumberInputContext'
import { StepperPrimitive } from '../primitives'

export const Decrement = () => {
  const { decrement, round, variant, isDecrementDisabled, isDisabled } =
    useContext(NumberInputContext)

  return (
    <StepperPrimitive.IconButton
      size="sm"
      onClick={(event) => {
        event.preventDefault()
        event.stopPropagation()
        decrement()
      }}
      left
      round={round}
      variant={variant === 'default' ? undefined : 'outlineDark'}
      disabled={isDecrementDisabled || isDisabled}
    >
      <Minus />
    </StepperPrimitive.IconButton>
  )
}
